import { render, staticRenderFns } from "./BookPcCalalog.vue?vue&type=template&id=52ea7cb9&scoped=true&"
import script from "./BookPcCalalog.vue?vue&type=script&lang=js&"
export * from "./BookPcCalalog.vue?vue&type=script&lang=js&"
import style0 from "./BookPcCalalog.vue?vue&type=style&index=0&id=52ea7cb9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ea7cb9",
  null
  
)

export default component.exports